import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Moment, I18N, GlobalContext } from 'commons';
import { clientTimeZone } from 'utils';

const ItemDate = ({ issuanceTime, endTime }) => {
  const { account: { timeZone } } = useContext(GlobalContext);

  return (
    <p className="date">
      <span>
        <I18N>weather.list.label.issued</I18N>
        :&nbsp;
        <Moment
          eb-test="ee_weatherAlertList_text_issuanceTime"
          tz={timeZone || clientTimeZone}
          format="YYYY-MM-DD HH:mm:ss z"
        >
          {`${issuanceTime}Z`}
        </Moment>
      </span>
      <span className="vertical-line">|</span>
      <span>
        <I18N>weather.list.label.expiring</I18N>
        :&nbsp;
        {endTime ? (
          <Moment
            eb-test="ee_weatherAlertList_text_expirationTime"
            tz={timeZone || clientTimeZone}
            format="YYYY-MM-DD HH:mm:ss z"
          >
            {`${endTime}Z`}
          </Moment>
        ) : (
          <I18N tag="time" i18n-aria-label>weather.date.noneProvided</I18N>
        )}
      </span>
    </p>
  );
};

ItemDate.propTypes = {
  issuanceTime: PropTypes.string,
  endTime: PropTypes.string
};

ItemDate.defaultProps = {
  issuanceTime: '',
  endTime: ''
};

export default ItemDate;
